export interface PatientOverviewFields {
  patient_id: number;
  number_of_completed_analyses: number;
  number_of_past_appointments: number;
  patsumm_state: string;
  patdmr_state: string;
  patient_overview_pipeline_state: PatientOverviewPipelineState;
}

export enum PatientOverviewPipelineState {
  NOT_READY_TO_START = 'NOT_READY_TO_START',
  READY_TO_START = 'READY_TO_START',
  EXECUTED_UP_TO_DATE = 'EXECUTED_UP_TO_DATE',
  EXECUTED_NOT_UP_TO_DATE = 'EXECUTED_NOT_UP_TO_DATE',
  IN_PROGRESS = 'IN_PROGRESS',
}
